import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    Paper, Select, InputLabel, FormControl, MenuItem
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }
});

const RaspberryEraseStationForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    const statuses = [
        { value: 'active', displayValue: translations["active"] || "Active" },
        { value: 'inactive', displayValue: translations["inactive"] || "Inactive" }
    ];

    return (
        <Paper className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={{
                                    autoComplete: 'off'
                                }}
                            />
                            <TextField
                                name="MajorVersion"
                                value={values.MajorVersion || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MajorVersion && touched.MajorVersion)}
                                placeholder={translations["major_version"] || "Major version"}
                                label={translations["major_version"] || "Major version"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="MinorVersion"
                                value={values.MinorVersion || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MinorVersion && touched.MinorVersion)}
                                placeholder={translations["minor_version"] || "Minor version"}
                                label={translations["minor_version"] || "Minor version"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="BuildNumber"
                                value={values.BuildNumber || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.BuildNumber && touched.BuildNumber)}
                                placeholder={translations["build_number"] || "Build number"}
                                label={translations["build_number"] || "Build number"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="RemoteID"
                                value={values.RemoteID || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.RemoteID && touched.RemoteID)}
                                placeholder={"RemoteID"}
                                label={"RemoteID"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="RemotePassword"
                                value={values.RemotePassword || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.RemotePassword && touched.RemotePassword)}
                                placeholder={translations["remote_password"] || "Remote password"}
                                label={translations["remote_password"] || "Remote password"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["status_text"] || "Please select status"}</InputLabel>
                                <Select
                                    name="Status"
                                    label={translations["status"] || "Status"}
                                    margin={"dense"}
                                    value={values.Status || ""}
                                    onChange={handleChange}
                                    fullWidth={true}
                                    disabled={true}
                                >
                                    {(statuses ? [...statuses] : []).map(option => (
                                        <MenuItem key={option.value + 'key'} value={option.value}>
                                            {translations[option.value] || option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit && (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={!(isValid && dirty)}
                                    >
                                        {formSettings.ButtonSubmit.Title}
                                    </Button>
                                )}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(RaspberryEraseStationForm);
